interface ExportsErrorStateProps {
  message: string;
  onRetry: () => void;
}

export function ExportsErrorState({ message, onRetry }: ExportsErrorStateProps) {
  return (
    <div
      data-testid="exports-error-state"
      className="flex flex-col items-center justify-center py-20 text-center"
    >
      <svg
        className="mb-4 h-12 w-12 text-[var(--color-qup-error)]/60"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.5}
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
        />
      </svg>
      <p className="mb-4 text-sm text-[var(--color-qup-text-muted-dark)]">{message}</p>
      <button
        type="button"
        onClick={onRetry}
        className="rounded-[var(--radius-button)] border border-[var(--color-qup-border-dark)] px-3 py-1.5 text-sm text-[var(--color-qup-text-dark)] transition-colors hover:border-[var(--color-qup-primary)] hover:text-[var(--color-qup-primary)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-qup-primary)]"
      >
        Reintentar
      </button>
    </div>
  );
}
